/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
// src/themes/theme1/utils/theme1Helpers.js
export const buildImageUrl = (imageUrl) => {
  if (!imageUrl || imageUrl === "" || imageUrl.includes("undefined")) {
    return "https://placehold.co/400x400.png?text=No+Image";
  }

  if (typeof imageUrl === "string" && imageUrl.startsWith("http")) {
    return imageUrl;
  }

  // الرابط الأساسي للسيرفر بدون /api
  const cleanBaseUrl = "https://madar-api.madar.iq";

  // معالجة مسار اللوجو الخاص: TenantDtl/ID/FileName -> uploads/ID/TenantDtl/FileName
  const parts = imageUrl.replace(/^\/+/, "").split("/");
  if (parts.length >= 3 && (parts[0] === "TenantDtl" || parts[0] === "Logo")) {
    const folder = parts[0];
    const fileId = parts[1];
    const fileName = parts.slice(2).join("/");
    return `${cleanBaseUrl}/uploads/${fileId}/${folder}/${fileName}`;
  }

  // التأكد من أن المسار يبدأ بـ /
  const path = imageUrl.startsWith("/") ? imageUrl : `/${imageUrl}`;
  return `${cleanBaseUrl}${path}`;
};

export const n = (v) => {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
};

export const safeText = (v) => (typeof v === "string" ? v.trim() : "");

export const isPlanMarketingText = (value) => {
  const text = String(value || "").trim();
  if (!text) return false;
  const normalized = text.replace(/\s+/g, " ").toLowerCase();
  return (
    /باقة/.test(text) ||
    /تجريب/.test(text) ||
    /\btrial\b/.test(normalized) ||
    /\bfree plan\b/.test(normalized) ||
    (/مجاني/.test(text) && /(أسبوع|اسبوع)/.test(text))
  );
};

export const publicStoreText = (...values) => {
  for (const value of values) {
    const text = String(value || "").trim();
    if (text && !isPlanMarketingText(text)) return text;
  }
  return "";
};

export const NO_COLOR_KEY = "__no_color__";

export function getVariantColorHex(variant) {
  const raw = String(
    variant?.color?.hex ||
    variant?.color?.hexCode ||
    variant?.colorHex ||
    ""
  ).trim();
  if (!raw || raw === "#" || raw === NO_COLOR_KEY) return "";
  return raw;
}

export function groupVariantsByColor(variants = []) {
  const groups = {};
  variants.forEach((v) => {
    const hex = getVariantColorHex(v);
    const key = hex || NO_COLOR_KEY;
    if (!groups[key]) {
      groups[key] = {
        hex: key,
        hasColor: Boolean(hex),
        variants: [],
        name: v.variantName || v.color?.name || "",
      };
    }
    groups[key].variants.push(v);
  });
  return groups;
}
